require.register("app/dashboard/IndexView", function(exports, require, module){
  $0
  
});

